<!-- Young -->
<template>
  <a-modal v-model="isShow" title="删除" width="342px" class="public-del" centered :closable="false">
      <div class="desc-wrap">
        {{delDesc}}
      </div>
      <template slot="footer">
        <a-button key="back" type="primary" class="footer-btn" @click="delTableDataFun" :loading="btnLoading">确定</a-button>
        <a-button key="submit" @click="isShow=false" class="footer-btn" style="margin-right: 0; background: #ECEDFF;">取消</a-button>
      </template>
  </a-modal>
</template>

<script>
export default {
  name: 'PublicDel',
  props: {
    delDesc: { required: true, type: String },
    btnLoading: { required: true, type: Boolean, default: false },
    delTableDataFun: { required: true, type: Function }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    // 监听属性 类似于data概念
  },
  watch: {
    // 监控data中的数据变化
  },
  methods: {
    // 下载日志
    downLoadRecord () {}
  },
  mounted () {
    // 生命周期-挂载完成(可以访问DOM元素)
  }
}
</script>
<style lang='less'>
  // @import url(); 引入公共css类
  .public-del {
  height: 193px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
      .ant-modal-title {
        font-size: 16px !important;
        color: #333333 !important;
      }
    }
    .ant-modal-body {
      height: 74px;
      padding: 0;
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
  }
  .footer-btn {
    width:88px;
    height:32px;
    margin-right: 32px;
    border-radius:3px;
    border: 0px;
  }
  .desc-wrap {
    padding: 16px;
    font-size: 16px;
    color: #333333;
  }
}
</style>
